<div>
  <button mat-button color="primary" (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>{{'portal.generic.uitloggen' | translate }}</span>
  </button>
</div>
